const image = `
  fragment image on UploadFile {
    id
    url
    alternativeText
    caption
  }
`;

const sliderImage = `
  fragment sliderImage on ComponentMediaImage {
    id
    title
    description
    image {
      ...image
    }
  }
  ${image}
`;

const teaser = `
  fragment teaser on ComponentTeaserCardTeaser {
    id
    title
    description
    image {
      ...image
    }
  }
  ${image}
`;

const teasers = `
  fragment teasers on ComponentModulesTeasers {
    id
    title
    description
    footnote
    teasers {
      ...teaser
    }
  }
  ${teaser}
`;

const banner = `
  fragment banner on ComponentMediaBanner {
    id
    title
    description
    portrait {
      ...image
    }
    background {
      ...image
    }
  }
  ${image}
`;

const openingHour = `
  fragment openingHour on ComponentTeaserOpeningHour {
    id
    title
    hours
  }
`;

const openingHours = `
  fragment openingHours on ComponentModulesOpeningHours {
    id
    title
    opening_hours {
      ...openingHour
    }
  }
  ${openingHour}
`;

const textImage = `
  fragment textImage on ComponentModulesTextImage {
    id
    text
    image {
      ...image
    }
  }
`;

const service = `
  fragment service on ComponentTeaserService {
    id
    icon_name
    title
    description
  }
`;

const services = `
  fragment services on ComponentModulesServices {
    id
    title
    description
    services {
      ...service
    }
  }
  ${service}
`;

const slider = `
  fragment slider on ComponentModulesSlider {
    id
    images {
      ...sliderImage
    }
  }
  ${sliderImage}
`;

const newsItem = `
  fragment newsItem on NewsItem {
    id
    title
    content
    updated_at
  }
`;

const newsItems = `
  fragment newsItems on ComponentModulesNewsItems {
    title
    description
    news_items {
      title
      ...newsItem
    }
  }
  ${newsItem}
`;

export default {
  image,
  banner,
  teaser,
  teasers,
  openingHour,
  openingHours,
  service,
  services,
  textImage,
  slider,
  newsItem,
  newsItems,
};
